module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_4.ed2b110f.png";